import React, { useEffect, useState } from "react";
import { Add, Route as RouteIcon } from "@mui/icons-material";
import { Box, Button, Paper, Typography } from "@mui/material";
import { toast } from "react-toastify";

import FormDrawer from "components/Shared/FormDrawer";
import RouteShipmentStopForm from "./RouteShipmentStopsForm";
import RouteShipmentStopsList from "./RouteShipmentStopList";
import { useRouteShipmentDetailContext } from "contexts/RouteShipmentDetailContext";
import {
  useAddRouteStopMutation,
  useUpdateRouteStopMutation, // Add this
  useLazyListRouteStopsQuery,
} from "store/services/routeShipmentApi";

const RouteShipmentStopsTab = () => {
  const [showStopForm, setShowStopForm] = useState(false);
  const [selectedStop, setSelectedStop] = useState(null);

  const { routeShipmentDetail } = useRouteShipmentDetailContext();
  const routeShipmentId = routeShipmentDetail?._id;
  const isActive = routeShipmentDetail?.isActive;

  const [fetchStops, { data: stopsRes, isLoading }] = useLazyListRouteStopsQuery();
  const [addStop, { isLoading: addingStop }] = useAddRouteStopMutation();
  const [updateStop, { isLoading: updatingStop }] = useUpdateRouteStopMutation(); // Add this

  useEffect(() => {
    if (routeShipmentId && isActive) {
      fetchStops(routeShipmentId).catch(() => {
        toast.error("Failed to fetch stops!");
      });
    }
  }, [routeShipmentId, fetchStops, isActive]);

  const handleCancelStop = () => {
    setShowStopForm(false);
    setSelectedStop(null);
  };

  const handleAddStop = async (data) => {
    if (!routeShipmentId) {
      toast.error("Route shipment ID is missing!");
      return;
    }



      const payload = {
        stopOrigin: data.origin._id,
        stopDestination: data.destination._id,
        stopDistance: Number(data.distance),
        stopTime: Number(data.time),
        stopCost: Number(data.cost),
      };

      await addStop({ shipmentId: routeShipmentId, ...payload }).unwrap();
      toast.success("Stop added successfully!");
      handleCancelStop();
      fetchStops(routeShipmentId);
    
  };

  const handleUpdateStop = async (data) => {
    if (!routeShipmentId) {
      toast.error("Route shipment ID is missing!");
      return;
    }


      const payload = {
        stopOrigin: data.origin._id,
        stopDestination: data.destination._id,
        stopDistance: Number(data.distance),
        stopTime: Number(data.time),
        stopCost: Number(data.cost),
      };

      await updateStop({
        shipmentId: routeShipmentId,
        stopId: selectedStop._id,
        ...payload,
      }).unwrap();
      toast.success("Stop updated successfully!");
      handleCancelStop();
      fetchStops(routeShipmentId);
    
  };

  const stops = Array.isArray(stopsRes) ? [...stopsRes] : [];
  const previousStop = stops.length > 0 ? stops[stops.length - 1] : null;

  return (
    <>
      {isActive ? (
        <>
          <Box display="flex" justifyContent="end" padding={3}>
            {!showStopForm && (
              <Button
                startIcon={<Add />}
                variant="outlined"
                onClick={() => setShowStopForm(true)}
              >
                Add Stop
              </Button>
            )}
          </Box>

          <RouteShipmentStopsList
            stops={stops}
            isLoading={isLoading}
            onEdit={(stop) => {
              setSelectedStop(stop);
              setShowStopForm(true);
            }}
          />

<FormDrawer
  title={selectedStop ? "Edit Route Stop" : "Add Route Stop"}
  open={showStopForm}
  onClose={handleCancelStop}
>
  <RouteShipmentStopForm
    isBusy={selectedStop ? updatingStop : addingStop}
    stop={selectedStop}
    shipmentId={routeShipmentId}
    onCancel={handleCancelStop}
    onSubmit={selectedStop ? handleUpdateStop : handleAddStop}
    previousStop={!selectedStop ? previousStop : null} // 👈 only pass when adding
  />
</FormDrawer>

        </>
      ) : (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "background.paper",
            borderRadius: 2,
            p: 4,
          }}
        >
          <Paper
            elevation={0}
            sx={{
              p: 4,
              textAlign: "center",
              maxWidth: 500,
              borderRadius: 2,
              width: "100%",
            }}
          >
            <Box
              sx={{
                bgcolor: "action.hover",
                width: 80,
                height: 80,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
                mb: 3,
              }}
            >
              <RouteIcon color="disabled" sx={{ fontSize: 40 }} />
            </Box>
            <Typography variant="h5" color="text.secondary" gutterBottom>
              Stops Unavailable
            </Typography>
            <Typography variant="body1" color="text.secondary">
              You can only manage stops when the Route Shipment is active.
            </Typography>
          </Paper>
        </Box>
      )}
    </>
  );
};

export default RouteShipmentStopsTab;